import { Component, Host, Prop, h } from '@stencil/core';

import { onFireDREvent } from '../../../actions/actions.offer';

@Component({
  tag: 'offer-further-review-normal',
  styleUrl: 'offer-further-review-normal.css',
})
export class OfferFurtherReviewNormal {
  @Prop() offerId: string = '';
  @Prop() email: string = '';
  @Prop() zipCode: string = '';
  @Prop() vehicleShortDescription: string = '';
  @Prop() whenReviewVehicleDetailsClicked: (evt: MouseEvent) => void = () => {};
  @Prop() useTradeIn: boolean = false;
  @Prop() tradeInBtnText: string = '';
  @Prop() showIcoQuestionsSection: boolean = true;
  @Prop() isOfficeClosed: boolean = false;
  @Prop() showKelleyBuysYourCar: boolean = false;

  render() {
    return (
      <Host>
        <h2 class="mb-4">
          {!this.showKelleyBuysYourCar ? (
            <span>Thanks for requesting a Kelley Blue Book&#174; Instant Cash Offer for your vehicle.</span>
          ) : (
            <span>Thanks for requesting a Kelly Buys Your Car Offer for your vehicle.</span>
          )}
        </h2>

        {this.isOfficeClosed ? (
          <div class="mb-6">
            <div class="mb-2">A Kelley Blue Book representative needs to review your information, but our offices are closed.</div>
            <div>We'll send you an email when we have an update - usually the next business day.</div>
          </div>
        ) : (
          <div class="mb-6">A Kelley Blue Book representative is still reviewing your information. We'll send you an email when we have an update.</div>
        )}
        <div class="mb-6">
          <div class="font-bold">Why did my vehicle go into review?</div>
          Some vehicles are rare, making it difficult to establish a solid sales history. We may also need to review the condition of certain items before making an offer.
          Additionally, specific equipment, particularly vehicle modifications, may require special consideration.
        </div>
        <offer-hurricane-warning zipCode={this.zipCode} isFurtherReviewNormal={true} />

        <div class="text-center md:text-left mb-6">
          <div class="font-bold">{this.vehicleShortDescription}</div>

          <div>
            <a href="#" class="no-underline" onClick={(evt) => this.whenReviewVehicleDetailsClicked(evt)}>
              Review vehicle details
            </a>
          </div>
        </div>

        <div class="text-center md:text-left text-xs mb-8">
          <div>Offer ID: {this.offerId}</div>
          {this.email && <div>Email: {this.email}</div>}
          <div>ZIP Code: {this.zipCode}</div>
        </div>

        {!this.showKelleyBuysYourCar && (
          <p class="xs:text-center md:text-left">
            Questions about the Instant Cash Offer program? <span class="font-bold">Call (866) 559-5268</span>
          </p>
        )}

        {this.useTradeIn && (
          <div class="flex xs:justify-center md:justify-start w-full xs:pb-9 md:pb-6">
            <ico-button buttonStyle="final-action" label={this.tradeInBtnText} whenClicked={onFireDREvent.bind(this, this.tradeInBtnText)} />
          </div>
        )}
      </Host>
    );
  }
}
